import React from 'react';

const LockV3 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    style: { ...style, overflow: "visible" },
    className,
    width: "18",
    height: "22",
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 6C3 4.4087 3.63214 2.88258 4.75736 1.75736C5.88258 0.632141 7.4087 0 9 0C10.5913 0 12.1174 0.632141 13.2426 1.75736C14.3679 2.88258 15 4.4087 15 6H16C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V8C0 7.46957 0.210714 6.96086 0.585786 6.58579C0.960859 6.21071 1.46957 6 2 6H3ZM9 2C10.0609 2 11.0783 2.42143 11.8284 3.17157C12.5786 3.92172 13 4.93913 13 6H5C5 4.93913 5.42143 3.92172 6.17157 3.17157C6.92172 2.42143 7.93913 2 9 2ZM11 12C11 12.3511 10.9076 12.6959 10.732 13C10.5565 13.304 10.304 13.5565 10 13.732V15C10 15.2652 9.89464 15.5196 9.70711 15.7071C9.51957 15.8946 9.26522 16 9 16C8.73478 16 8.48043 15.8946 8.29289 15.7071C8.10536 15.5196 8 15.2652 8 15V13.732C7.61874 13.5119 7.32077 13.1721 7.15231 12.7653C6.98384 12.3586 6.95429 11.9076 7.06824 11.4824C7.18219 11.0571 7.43326 10.6813 7.78253 10.4133C8.1318 10.1453 8.55975 10 9 10C9.53043 10 10.0391 10.2107 10.4142 10.5858C10.7893 10.9609 11 11.4696 11 12Z",
      fill: "url(#paint0_linear_20100_1661320)"
    }
  ),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint0_linear_20100_1661320",
      x1: "3.44531",
      y1: "6.0536e-09",
      x2: "3.44531",
      y2: "8",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#FFF8D8" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.495192", stopColor: "#FFCA37" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#FFC56C" })
  ))
);
LockV3.displayName = "Icons.LockV3";

export { LockV3 };
//# sourceMappingURL=LockV3.js.map
